import axios from "axios";

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

export interface PodcastEpisode {
  id: string;
  title: string;
  description: string | null;
  guest_name: string | null;
  guest_title: string | null;
  episode_number: number | null;
  thumbnail_url: string | null;
  spotify_url: string | null;
  youtube_url: string | null;
  topics: string[];
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export interface UpsertEpisodePayload {
  title: string;
  description?: string | null;
  guest_name?: string | null;
  guest_title?: string | null;
  episode_number?: number | null;
  thumbnail_url?: string | null;
  spotify_url?: string | null;
  youtube_url?: string | null;
  topics?: string[];
  is_active?: boolean;
  display_order?: number;
}

export const podcastEpisodesApi = {
  list: () =>
    axios
      .get<{ data: PodcastEpisode[] }>(`${API_BASE}/admin/podcast/episodes`, {
        withCredentials: true,
      })
      .then((r) => r.data),

  create: (payload: UpsertEpisodePayload) =>
    axios
      .post<{ data: PodcastEpisode }>(`${API_BASE}/admin/podcast/episodes`, payload, {
        withCredentials: true,
      })
      .then((r) => r.data),

  update: (id: string, payload: Partial<UpsertEpisodePayload>) =>
    axios
      .patch<{ data: PodcastEpisode }>(`${API_BASE}/admin/podcast/episodes/${id}`, payload, {
        withCredentials: true,
      })
      .then((r) => r.data),

  delete: (id: string) =>
    axios
      .delete(`${API_BASE}/admin/podcast/episodes/${id}`, { withCredentials: true })
      .then((r) => r.data),

  createUploadUrl: (payload: { filename: string; content_type: string }) =>
    axios
      .post<{ upload_url: string; file_url: string; key: string }>(
        `${API_BASE}/admin/podcast/episodes/upload-url`,
        payload,
        { withCredentials: true },
      )
      .then((r) => r.data),
};
